// Constante partajate între Inventar.jsx și subcomponente
export const ITEM_TYPES = [
  { code: "echipament", label: "Echipament" },
  { code: "consumabil", label: "Consumabil" },
  { code: "piesa_auto", label: "Piesă auto" },
  { code: "psa", label: "PSA" },
];

export const TYPE_LABELS = {
  echipament: "Echipament",
  consumabil: "Consumabil",
  psa: "PSA",
};

export const TYPE_ICONS = {
  echipament: "🔧",
  consumabil: "📦",
  psa: "🦺",
};

export const TYPE_COLORS = {
  echipament: { bg: "bg-blue-50",   border: "border-blue-200",   text: "text-blue-800",   activeBg: "bg-blue-600", activeText: "text-white" },
  consumabil: { bg: "bg-amber-50",  border: "border-amber-200",  text: "text-amber-800",  activeBg: "bg-amber-600", activeText: "text-white" },
  psa:        { bg: "bg-cyan-50",   border: "border-cyan-200",   text: "text-cyan-800",   activeBg: "bg-cyan-600", activeText: "text-white" },
};

export const EMPTY_ITEM = {
  name: "", item_type: "echipament", location: "", color: "",
  shelf_col: "", shelf_row: "",
  status: "functional", quantity: 1, unit: "",
  warranty_until: "", purchase_date: "",
  store_id: "", linked_car_id: "", linked_equipment_id: "", is_oil: false, car_consumable_type: null,
  serial: "",
  no_serial: false,
  note: "",
  supplier: "",
  price_chf: null,
  assigned_at: "",   // optional: data atribuirii (când a fost predat / pus în locație)
};
